export enum WindowShape {
  TransomWithUpperLeftArch = 'transom-with-upper-left-arch',
  TransomWithUpperRightArch = 'transom-with-upper-right-arch',
  TransomWithUpperLeftFullArch = 'transom-with-upper-left-full-arch',
  TransomWithUpperRightFullArch = 'transom-with-upper-right-full-arch',
  Transom = 'transom',
  Square = 'square',
  Octagon = 'octagon',
  Diamond = 'diamond',
}
